import React from "react";

import type {
  Reference,
  ReferenceValidation,
} from "../../../../application/domain/proc-management";
import { getMaxLength } from "../../../../application/domain/proc-management/util/input-max-length";
import { FormFieldLabel } from "../../../atoms/proc-management/form";
import { SimpleTextInput } from "./simple-text-input";
import type { InputProps, PathProps } from "./types";

type Props = Reference &
  PathProps &
  InputProps & { validationErrors?: ReferenceValidation };

const ReferenceInput: React.FC<Props> = ({
  name,
  url,
  onChange,
  basePath,
  disabled = false,
  shouldDisplayError,
  validationErrors,
}) => {
  return (
    <div>
      <div className="mb-2">
        <FormFieldLabel label="リファレンス名" bold={false} required />
        <SimpleTextInput
          onChange={onChange}
          basePath={[...basePath, "name"]}
          value={name}
          disabled={disabled}
          shouldDisplayError={shouldDisplayError}
          errorMsg={validationErrors?.name}
          maxLength={getMaxLength("referenceName")}
        />
      </div>

      <div className="mb-2">
        <FormFieldLabel label="リファレンスURL" bold={false} required />
        <SimpleTextInput
          onChange={onChange}
          basePath={[...basePath, "url"]}
          value={url}
          disabled={disabled}
          shouldDisplayError={shouldDisplayError}
          errorMsg={validationErrors?.url}
        />
      </div>
    </div>
  );
};

export default ReferenceInput;
